// Mobile Navigation Controller
class MobileNavigation {
  constructor() {
    this.nav = document.getElementById('mobileNav');
    this.cartCountElement = document.getElementById('cartCount');
    this.lastScrollTop = 0;
    this.isVisible = true;
    
    this.init();
  }
  
  init() {
    if (!this.nav) return;
    
    this.updateCartCount();
    this.setupEventListeners();
    this.setupScrollBehavior();
    this.applyCustomStyles();
  }
  
  setupEventListeners() {
    // Cart update listeners
    document.addEventListener('cart:updated', () => this.updateCartCount());
    window.addEventListener('cart:updated', () => this.updateCartCount());
    
    // Click animations
    const navItems = document.querySelectorAll('.nav-item');
    navItems.forEach(item => {
      item.addEventListener('click', (e) => this.handleNavClick(e, item));
    });
    
    // Keyboard navigation
    navItems.forEach(item => {
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        }
      });
    });
  }
  
  setupScrollBehavior() {
    let ticking = false;
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
  }
  
  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > this.lastScrollTop && scrollTop > 100) {
      // Scrolling down
      this.hideNav();
    } else {
      // Scrolling up
      this.showNav();
    }
    
    this.lastScrollTop = scrollTop;
  }
  
  hideNav() {
    if (this.isVisible) {
      this.nav.classList.add('hide');
      this.nav.classList.remove('show');
      this.isVisible = false;
    }
  }
  
  showNav() {
    if (!this.isVisible) {
      this.nav.classList.add('show');
      this.nav.classList.remove('hide');
      this.isVisible = true;
    }
  }
  
  handleNavClick(event, item) {
    // Add click animation
    item.style.transform = 'translateY(0) scale(0.95)';
    setTimeout(() => {
      item.style.transform = '';
    }, 150);
    
    // Track navigation (if analytics are available)
    if (typeof gtag !== 'undefined') {
      gtag('event', 'mobile_nav_click', {
        'nav_item': item.querySelector('.nav-label').textContent
      });
    }
  }
  
  updateCartCount() {
    if (!this.cartCountElement) return;
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const count = cart.item_count;
        this.cartCountElement.textContent = count;
        
        if (count > 0) {
          this.cartCountElement.classList.add('show');
          // Trigger pulse animation
          this.cartCountElement.style.animation = 'none';
          this.cartCountElement.offsetHeight; // Trigger reflow
          this.cartCountElement.style.animation = 'pulse 0.5s ease-in-out';
        } else {
          this.cartCountElement.classList.remove('show');
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }
  
  applyCustomStyles() {
    // Apply custom colors from theme settings
    const navBgColor = this.nav.dataset.bgColor;
    const navTextColor = this.nav.dataset.textColor;
    const navActiveColor = this.nav.dataset.activeColor;
    
    if (navBgColor) {
      document.documentElement.style.setProperty('--nav-bg-color', navBgColor);
    }
    if (navTextColor) {
      document.documentElement.style.setProperty('--nav-text-color', navTextColor);
    }
    if (navActiveColor) {
      document.documentElement.style.setProperty('--nav-active-color', navActiveColor);
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new MobileNavigation();
});

// Reinitialize after AJAX cart updates (for themes that use AJAX)
document.addEventListener('DOMContentLoaded', () => {
  // Listen for common AJAX cart events
  const ajaxEvents = ['cart:updated', 'cart:build', 'cart:refresh'];
  
  ajaxEvents.forEach(eventName => {
    document.addEventListener(eventName, () => {
      setTimeout(() => {
        const mobileNav = document.getElementById('mobileNav');
        if (mobileNav) {
          new MobileNavigation();
        }
      }, 100);
    });
  });
});

// Export for potential external use
window.MobileNavigation = MobileNavigation;